import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Resumen = {
  aprendizajesTexto?: string | string[];
  criteriosTexto?: string | string[];
  objetivosGenericosTexto?: string | string[];
};

type Objetivo = {
  codigo: string;
  objetivo: string;
};

interface Props {
  open: boolean;
  objetivo: Objetivo;
  resumen: Resumen;
  onBack: () => void;
  onFinish: () => void; 
}

function toList(value?: string | string[]) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  const s = value.trim();
  if (!s) return [];
  return [s];
}

function ResumenBlock({ title, value }: { title: string; value?: string | string[] }) {
  const items = toList(value);

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontWeight: 700,
          color: "#666666",
          fontSize: "12px",
          mb: 0.5,
        }}
      >
        {title}
      </Typography>

      {items.length === 0 ? (
        <Typography
          sx={{
            fontFamily: "Montserrat",
            color: "rgba(0,0,0,0.6)",
            fontSize: "10px",
          }}
        >
          —
        </Typography>
      ) : (
        <Stack spacing={0.4} sx={{ pl: 1 }}>
          {items.map((t, idx) => (
            <Typography
              key={`${title}-${idx}`}
              sx={{
                fontFamily: "Montserrat",
                color: "rgba(0,0,0,0.72)",
                fontSize: "10px",
              }}
            >
              • {t}
            </Typography>
          ))}
        </Stack>
      )}
    </Box>
  );
}

export default function ObjectiveSelectionReviewModal({
  open,
  objetivo,
  resumen,
  onBack,
  onFinish,
}: Props) {
  return (
    <Dialog open={open} onClose={onBack} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontFamily: "Montserrat" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                color: "OA-TP OBJ 01 ",
                fontSize: "0.9rem",
              }}
            >
              {objetivo.codigo}
            </Typography>

            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 800,
                color: "#234C61",
                fontSize: "1.1rem",
                mt: 0.5,
              }}
            >
              Objetivo de Aprendizaje (seleccionado)
            </Typography>
          </Box>

          <IconButton onClick={onBack}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }}>
        
          <Box
            sx={{
              maxHeight: 220, 
              overflowY: "auto",
              pr: 1,
              position: "relative",
              zIndex: 1,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                color: "rgba(0,0,0,0.72)",
                fontSize: "12px",
                mb: 1,
              }}
            >
              {objetivo.objetivo}
            </Typography>

            <Stack spacing={1} sx={{ p: 1 }}>
              <ResumenBlock title="Aprendizajes esperados:" value={resumen.aprendizajesTexto} />
              <ResumenBlock title="Criterios de evaluación:" value={resumen.criteriosTexto} />
              <ResumenBlock title="Objetivos genéricos:" value={resumen.objetivosGenericosTexto} />
            </Stack>
          </Box>
      
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onBack} variant="text" sx={{ fontFamily: "Montserrat", fontWeight: 700, color: "#336B87" }}>
          VOLVER A Objetivos genericos
        </Button>

        <Button
          onClick={onFinish}
          variant="contained"
         sx={{
                borderRadius: "12px",
                px: 3,
                fontFamily: "Montserrat",
                fontWeight: 600,
                backgroundColor: "#1FC16B",
                "&:hover": { backgroundColor: "#1ba75cff" },
              }}
        >
          Seleccionar objetivos y continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
